<template>
	<a-layout-footer>
		<a-row type="flex">
			<a-col :span="24" :md="12">
				<p class="copyright">
					© {{ anioActual }}
					by <a href="https://www.netplus.com.ve">INTERCOM SERVICIOS C.A</a>
				</p>
			</a-col>
			<a-col :span="24" :md="12" class="footer-control">
				<a-menu mode="horizontal">
					<a-menu-item><a href="https://www.netplus.com.ve" target="_blank">Netplus</a></a-menu-item>
					<a-menu-item><a href="https://www.netplus.com.ve/planes-residenciales/" target="_blank">Planes Internet</a></a-menu-item>  
					<a-menu-item><a href="https://www.netplus.com.ve/planes-iptv/" target="_blank">Planes IPTV</a></a-menu-item>
					<a-menu-item><a href="https://www.netplus.com.ve/listado-de-canales/" target="_blank">Lista de Canales</a></a-menu-item>
					<a-menu-item><router-link to="/helpdesk">Ayuda</router-link></a-menu-item>
				</a-menu>
			</a-col>
		</a-row>
	</a-layout-footer>
</template>
<script setup>
import { useRouter } from 'vue-router';
import { dayjs } from '@/plugins/dayjs_intercom';
const anioActual = dayjs().year();
const router = useRouter();
</script>